module.exports = __webpack_public_path__ + "static/media/WRDivision2ENotation.a7dd3f65.jpg";